import { styled } from '@mui/material/styles';
import { getIdvThemeTokens } from '../themeTokens';
import type { IdvBannerTone } from './types';

export const BannerRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: IdvBannerTone }>(({ theme, tone }) => {
  const t = getIdvThemeTokens(theme).banner[tone];
  return {
    margin: '16px 0 0',
    padding: '12px 14px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 11,
    border: `1px solid ${t.border}`,
    borderRadius: 9,
    color: t.color,
    background: t.background,
  };
});

export const BannerIcon = styled('span')({
  width: 21,
  height: 21,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  border: '1px solid currentColor',
  borderRadius: '50%',
  fontSize: 12,
  fontWeight: 700,
});

export const BannerCopyBlock = styled('div')({
  flex: 1,
  minWidth: 0,
});

export const BannerTitle = styled('strong')({
  display: 'block',
  fontSize: 13,
  fontWeight: 700,
});

export const BannerCopy = styled('p')({
  margin: '2px 0 0',
  fontSize: 12,
  lineHeight: 1.45,
});

export const BannerMeta = styled('small')(({ theme }) => ({
  display: 'block',
  marginTop: 4,
  color: getIdvThemeTokens(theme).textMeta,
  fontSize: 11,
}));
